import { css } from '@linaria/atomic';
import { cx } from '@linaria/atomic';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { theme } from '@frontend/theme';
import { CaretLeftIconSmall } from '../../../icon/icons-small/caret-left-small';
import { CaretRightIconSmall } from '../../../icon/icons-small/caret-right-small';
import { NakedButton } from '../../../naked/naked-button.component';

type CarouselArrowProps = CommonHTMLButtonAttributes & {
  direction: 'left' | 'right';
  show: boolean;
  trackingId?: string;
};

export const CarouselArrow = ({ direction, show, ...rest }: CarouselArrowProps) => {
  if (!show) return null;

  const IconComponent = direction === 'left' ? CaretLeftIconSmall : CaretRightIconSmall;

  return (
    <NakedButton {...rest} className={cx(arrowBaseStyle, direction === 'left' ? arrowLeftStyle : arrowRightStyle)}>
      <IconComponent />
    </NakedButton>
  );
};

const arrowBaseStyle = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: ${theme.spacing(1.5)} ${theme.spacing(0.5)};
  box-shadow: 0px 4px 8px 3px #00215226;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.colors.white};
`;

const arrowLeftStyle = css`
  left: -${theme.spacing(2)};
`;

const arrowRightStyle = css`
  right: -${theme.spacing(2)};
`;
